import React from 'react';
import Icon, { IconProps } from '../Icon';

const ComputerIcon: React.FC<IconProps> = (props) => {
  return (
    <Icon {...props}>
      <svg
        width="100%"
        height="100%"
        viewBox="0 0 40 39"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M35.5772 31.1395C36.7501 31.1395 37.8752 30.6619 38.7043 29.8113C39.5338 28.9607 40 27.8075 40 26.6047V4.53482C40 3.33208 39.5338 2.17847 38.7043 1.32826C37.8751 0.477686 36.7501 0 35.5772 0H4.42281C3.24987 0 2.12484 0.477659 1.2957 1.32826C0.466201 2.17849 0 3.33208 0 4.53482V26.6047C0 27.8075 0.466166 28.9607 1.2957 29.8113C2.12486 30.6619 3.24987 31.1395 4.42281 31.1395H16.1671V37.9923H10.5163C10.2448 37.9923 10.0247 38.218 10.0247 38.4963C10.0247 38.7743 10.2448 39 10.5163 39H29.4841C29.7556 39 29.9756 38.7744 29.9756 38.4963C29.9756 38.218 29.7556 37.9923 29.4841 37.9923H23.8332V31.1395H35.5772ZM0.983051 4.53473C0.983051 3.59941 1.34536 2.70214 1.99041 2.04062C2.6355 1.37913 3.51022 1.00767 4.42272 1.00767H35.5771C36.4895 1.00767 37.3643 1.37918 38.0094 2.04062C38.6545 2.70211 39.0168 3.59941 39.0168 4.53473V22.5736H0.982876L0.983051 4.53473ZM22.8501 37.9923H17.1498V31.1395H22.8501V37.9923ZM4.42281 30.1319C3.5104 30.1319 2.63563 29.7604 1.9905 29.0989C1.3454 28.4374 0.983139 27.5401 0.983139 26.6048V23.5814H39.017V26.6048C39.017 27.5401 38.6547 28.4374 38.0097 29.0989C37.3646 29.7604 36.4899 30.1319 35.5774 30.1319H4.42281Z"
          fill="currentColor"
        />
      </svg>
    </Icon>
  );
};

export default ComputerIcon;
